module.exports = __webpack_public_path__ + "static/media/logo_agifly.b120a222.svg";